export const clearLocalStorageExcept = (key: string) => {
  // Define all token-related localStorage keys grouped by user type
  const tokenKeys = {
    affiliate: ["user", "token"],
    brand: ["brand_user", "brand_token"],
    admin: ["admin_user", "admin_token", "admin_refresh_token"],
    agency: ["agency_user", "agency_token"],
  };

  // Get the keys to keep based on the current user type
  const keysToKeep = tokenKeys[key as keyof typeof tokenKeys] || [];

  // Remove all token-related keys except the ones we want to keep
  Object.values(tokenKeys)
    .flat()
    .forEach((tokenKey) => {
      if (!keysToKeep.includes(tokenKey)) {
        localStorage.removeItem(tokenKey);
      }
    });
};
